'use strict';
(function initializeCampaignSetting(root) {
  const app = root.dndNextLevel = root.dndNextLevel || {};
  const state = app.campaignSettingState;
  const campaign = app.campaignSetting = {currentDocument: null, activeSection: null};

  const status = (id, message) => {
    const element = root.document.getElementById(id);
    if (element) element.textContent = message;
  };
  const accept = document => {
    if (!state.isCanonical(document)) return;
    campaign.currentDocument = document;
    app.campaignSettingRecentAdapter?.saveCurrent(document, root.localStorage);
  };
  campaign.copyCampaign = async () => {
    const text = root.document.getElementById('campaign-setting-summary')?.innerText?.trim();
    if (!text || !root.navigator.clipboard?.writeText) {
      status('campaign-setting-action-status', 'Copy unavailable.');
      return false;
    }
    await root.navigator.clipboard.writeText(text);
    status('campaign-setting-action-status', 'Campaign copied.');
    return true;
  };
  campaign.saveCampaign = () => {
    if (!campaign.currentDocument) {
      status('campaign-setting-action-status', 'Save unavailable.');
      return false;
    }
    app.campaignSettingRecentAdapter?.saveCurrent(campaign.currentDocument, root.localStorage, true);
    status('campaign-setting-action-status', `${campaign.currentDocument.campaign.settingName} saved in this browser.`);
    return true;
  };
  campaign.setWorkbenchView = view => {
    const layout = root.document.querySelector('[data-component="controls-result-layout"]');
    if (!layout) return false;
    layout.querySelectorAll('[data-workbench-view]').forEach(panel => {
      panel.classList.toggle('hidden', panel.dataset.workbenchView !== view);
    });
    layout.querySelectorAll('[data-workbench-view-target]').forEach(button => {
      const selected = button.dataset.workbenchViewTarget === view;
      button.setAttribute('aria-pressed', String(selected));
      button.classList.toggle('bg-slate-900', selected);
      button.classList.toggle('text-white', selected);
    });
    return true;
  };
  const scrollBehavior = () => root.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const updateNavigation = section => {
    campaign.activeSection = section;
    const edit = root.document.getElementById('campaign-setting-edit-options');
    const view = root.document.getElementById('campaign-setting-view-result');
    if (!section || !edit || !view) return;
    edit.textContent = `Edit ${section.dataset.campaignSettingSectionLabel} options`;
    edit.setAttribute('aria-controls', section.id);
    view.textContent = `View ${section.dataset.campaignSettingSectionLabel} result`;
    view.setAttribute('aria-controls', section.dataset.campaignSettingSummaryTarget);
  };
  const initializeSections = () => {
    const sections = Array.from(root.document.querySelectorAll('[data-campaign-setting-section]'));
    if (!sections.length) return;
    const previousId = campaign.activeSection?.id;
    const active = sections.find(section => section.id === previousId)
      || sections.find(section => section.open) || sections[0];
    sections.forEach(section => {
      section.open = section === active;
      if (section.dataset.campaignSettingBound === 'true') return;
      section.dataset.campaignSettingBound = 'true';
      section.querySelector('summary')?.addEventListener('click', event => {
        event.preventDefault();
        sections.forEach(candidate => candidate.open = candidate === section);
        updateNavigation(section);
      });
    });
    updateNavigation(active);
  };
  const initializeViews = () => {
    root.document.querySelectorAll('[data-workbench-view-target]').forEach(button => {
      if (button.dataset.campaignSettingBound === 'true') return;
      button.dataset.campaignSettingBound = 'true';
      button.addEventListener('click', () => campaign.setWorkbenchView(button.dataset.workbenchViewTarget));
    });
    const edit = root.document.getElementById('campaign-setting-edit-options');
    const view = root.document.getElementById('campaign-setting-view-result');
    if (edit && edit.dataset.campaignSettingBound !== 'true') {
      edit.dataset.campaignSettingBound = 'true';
      edit.addEventListener('click', () => campaign.activeSection?.querySelector('summary')
        ?.scrollIntoView({behavior: scrollBehavior(), block: 'start'}));
    }
    if (view && view.dataset.campaignSettingBound !== 'true') {
      view.dataset.campaignSettingBound = 'true';
      view.addEventListener('click', () => root.document
        .getElementById(campaign.activeSection?.dataset.campaignSettingSummaryTarget)
        ?.scrollIntoView({behavior: scrollBehavior(), block: 'center'}));
    }
  };
  const initializeDialogs = () => {
    const dialog = root.document.getElementById('campaign-setting-reset-dialog');
    const open = root.document.getElementById('campaign-setting-reset');
    const cancel = root.document.getElementById('campaign-setting-reset-cancel');
    if (open && open.dataset.campaignSettingBound !== 'true') {
      open.dataset.campaignSettingBound = 'true';
      open.addEventListener('click', () => dialog?.showModal());
    }
    if (cancel && cancel.dataset.campaignSettingBound !== 'true') {
      cancel.dataset.campaignSettingBound = 'true';
      cancel.addEventListener('click', () => dialog?.close());
    }
  };
  const initializeActions = () => {
    const copy = root.document.getElementById('campaign-setting-copy');
    const save = root.document.getElementById('campaign-setting-save');
    const exportButton = root.document.getElementById('campaign-setting-export');
    const backupButton = root.document.getElementById('campaign-setting-backup');
    if (copy && copy.dataset.campaignSettingBound !== 'true') {
      copy.dataset.campaignSettingBound = 'true';
      copy.addEventListener('click', campaign.copyCampaign);
    }
    if (save && save.dataset.campaignSettingBound !== 'true') {
      save.dataset.campaignSettingBound = 'true';
      save.addEventListener('click', campaign.saveCampaign);
    }
    if (exportButton && exportButton.dataset.campaignSettingBound !== 'true') {
      exportButton.dataset.campaignSettingBound = 'true';
      exportButton.addEventListener('click', () => status('campaign-setting-transfer-status', 'Campaign exported.'));
    }
    if (backupButton && backupButton.dataset.campaignSettingBound !== 'true') {
      backupButton.dataset.campaignSettingBound = 'true';
      backupButton.addEventListener('click', () => status('campaign-setting-transfer-status', 'Campaign full backup downloaded.'));
    }
  };
  const initializeUi = () => {
    initializeSections();
    initializeViews();
    initializeDialogs();
    initializeActions();
  };
  campaign.initialize = () => {
    const existing = state.parseObject(root.localStorage?.getItem(state.currentKey()));
    if (!state.isCanonical(existing)) app.campaignSettingRecentAdapter?.consumeRestore(root.localStorage, root.sessionStorage);
    app.campaignSettingRecentAdapter?.migrateLegacy(root.localStorage);
    state.migrateCurrent(root.localStorage);
    app.persistedFragment?.start({onStored: accept});
    initializeUi();
  };

  root.document.addEventListener('htmx:afterSwap', event => {
    initializeUi();
    if (event.target?.id === 'campaign-setting-summary') {
      root.document.getElementById('campaign-setting-summary')?.focus({preventScroll: true});
      status('campaign-setting-update-status', `${campaign.activeSection?.dataset.campaignSettingSectionLabel || 'Campaign'} updated.`);
    }
  });
  root.document.addEventListener('DOMContentLoaded', campaign.initialize);
})(window);
